import { render, staticRenderFns } from "./BurgerBtn.vue?vue&type=template&id=78eb17f2"
import script from "./BurgerBtn.vue?vue&type=script&lang=js"
export * from "./BurgerBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports